import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "knudeaendring",
  "use": "knudeaendring-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" id=\"knudeaendring\"><path d=\"M26.11 8.87v1h-4.65a8.08 8.08 0 0 0-13 0H3.9v-1H1.65v9.72h2.07v-1h3.7a8.08 8.08 0 0 0 15.08 0h3.43v1h2.25V8.87z\" fill=\"#6d6e71\" stroke=\"#6d6e71\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".5\" /><circle cx=\"21.63\" cy=\"15.15\" r=\"6.88\" fill=\"#da9c28\" /><path d=\"M21.63 14V9.15l2.4 2.4zm0 7.2l-2.4-2.4 2.4-2.4zm3-9a4.2 4.2 0 0 1-3 7.17v-1.2a3 3 0 0 0 3-3 3 3 0 0 0-.88-2.17zm-3-1.23v1.2a3 3 0 0 0-2.12 5.12l-.84.85a4.15 4.15 0 0 1-1.24-3 4.2 4.2 0 0 1 4.2-4.2z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/knudeaendring.svg
// module id = ZBoA
// module chunks = 1